import { useNavigate } from 'react-router-dom';
import axe from '../../services/axios-client/axiosClient';
import { generalAlertError } from '../utils/alerts';
import { BACKOFFICE_PANEL_URL } from '../../config';
import { getProductNameForUrl } from '../constants';

export default function NotificationItem({ notification }) {
  const navigate = useNavigate();

  const getUrl = () => {
    const payload = notification.event_payload;
    if (payload.status && payload.status == 7) {
      if (payload.is_offline && payload.is_offline === 1) {
        return navigate(
          `/quotes/purchased/${payload.id}/quotation/offline`,
        );
      }

      return navigate(
        `/quotes/purchased/${payload.id}/quotation/${getProductNameForUrl(payload.product_id)}`,
      );
    }
    if (notification.event === 'thread') {
      return navigate(
        `/messages/${payload.id}`,
      );
    }

    if (notification.event === 'thread_request') {
      if (payload.request_status == 2 && payload.is_offline == 0) {
        return navigate(
          `/quotes/${getProductNameForUrl(payload.product_id)
          }/purchase/${payload.request_token}`,
        );
      }

      if (payload.request_status == 2 && payload.is_offline == 1) {
        return navigate(
          `/quotes/offline/purchase/${payload.request_token}`,
        );
      }

      if (payload.request_status == 1 && payload.is_offline == 0 && [1, 3].includes(payload.product_id)) {
        return navigate(
          `/quotes/${payload.request_token}`,
        );
      }

      if (payload.request_status == 1 && payload.is_offline == 0 && ![1, 3].includes(payload.product_id)) {
        return navigate(
          `/quotes/${getProductNameForUrl(payload.product_id)}/${payload.request_token}`,
        );
      }
    }

    if (notification.event === 'ticket') {
      return navigate(
        `/tickets/${payload.id}`,
      );
    }
    if (
      (notification.event === 'quotation.status_change'
        || notification.event === 'quotation.amount_change')
      && payload.product_id
    ) {
      if (payload.is_offline && payload.is_offline === 1) {
        return navigate(
          `/quotes/offline/purchase/${payload.request_token}`,
        );
      }
      return navigate(
        `/quotes/${getProductNameForUrl(payload.product_id)
        }/purchase/${payload.request_token}`,
      );
    }

    if (notification.event === 'quotation.optional_document.requested') {
      if (payload.is_offline && payload.is_offline === 1) {
        return navigate(
          `/quotes/offline/purchase/${payload.request_token}`,
        );
      }
      return navigate(
        `/quotes/${getProductNameForUrl(parseInt(payload.product_id))
        }/purchase/${payload.request_token}`,
      );
    }

    if (notification.event === 'replacement-requests.document' || notification.event === 'replacement-requests') {
      return navigate(
        `/replacements/${payload.id}`,
      );
    }
    if (notification.event === 'modification-requests.document' || notification.event === 'modification-requests') {
      return navigate(
        `/modifications/${payload.id}`,
      );
    }
    if (notification.event === 'replacement-requests.document' || notification.event === 'replacement-requests' || notification.event === 'replacement_request') {
      return navigate(
        `/replacements/${payload.id}`,
      );
    }
    if (notification.event === 'modification-requests.document' || notification.event === 'modification-requests' || notification.event === 'modification_request') {
      return navigate(
        `/modifications/${payload.id}`,
      );
    }
    if (notification.event === 'cancellation-requests.document' || notification.event === 'cancellation-requests' || notification.event === 'cancellation_request') {
      return navigate(
        `/cancellations/${payload.id}`,
      );
    }

    if (notification.event === 'suspension-requests.document' || notification.event === 'suspension-requests' || notification.event === 'suspension_request' || notification.event === 'suspensions') {
      return navigate(
        `/suspensions/${payload.id}`,
      );
    }
    if (notification.event === 'accident') {
      return navigate(
        `/accidents/${payload.id}`,
      );
    }
    if (notification.event === 'compensation.validation') {
      return navigate(
        '/profile/',
      );
    }
    if (notification.event === 'renewals-generated') {
      return navigate('/preventivi');
    }

    if (notification.event === 'quotation.new_quotation') {
      if (payload.product_id == 1) {
        return navigate(`/quotes/${payload.request_token}`);
      }
      if (payload.product_id == 2) {
        return navigate(`/quotes/moto/${payload.request_token}`);
      }
      if (payload.product_id == 3) {
        return navigate(`/quotes/${payload.request_token}`);
      }
      return navigate(`/quotes/${payload.request_token}`);
    }

    if (notification.event === 'replacements') {
      return navigate(`/replacements/${payload.id}`);
    }

    if (notification.event === 'modifications') {
      return navigate(`/modifications/${payload.id}`);
    }

    if (notification.event === 'cancellations') {
      return navigate(`/cancellations/${payload.id}`);
    }

    if (notification.event === 'accidents') {
      return navigate(`/accidents/${payload.id}`);
    }

    /* Fideiussioni e Cauzioni produces no quotation, so the request itself is what the broker
       opens — keyed by token, like the offline purchase routes above rather than by id. */
    if ((notification.event === 'cauzioni.status-change'
      || notification.event === 'cauzioni.document-invalid') && payload.request_token) {
      return navigate(`/quotes/surety-bonds/${payload.request_token}`);
    }

    return null;
  };

  const loginToPanel = async () => {
    const res = await axe.post('/backoffice/signin');

    if (res.status !== 200) {
      generalAlertError("Qualcosa e andato storto! Riprova o chiama l'amministratore dell sistema!");
    }
    window.open(`${BACKOFFICE_PANEL_URL}/broker-back-office/login/${res.data.data.token}`, '_blank');
  };

  return (
    <div
      className={`alert alert-${notification.is_read === 0 ? 'success' : 'secondary'
      } mt-2 py-2 py-sm-4`}
    >
      <div className="d-flex flex-column flex-sm-row align-items-center justify-content-between">
        <span>{notification.text}</span>
        {notification.event === 'quotation.to_capture' ? (
          <div
            onClick={() => loginToPanel()}
            className={`btn btn-sm m-2 py-2 btn-${notification.is_read === 0 ? 'success' : 'secondary'
            }`}
          >
            Vai
          </div>
        ) : (
          <div
            onClick={() => getUrl()}
            className={`btn btn-sm mt-3 mt-sm-0 py-2 px-3 btn-${notification.is_read === 0 ? 'success' : 'secondary'
            }`}
          >
            Vai
          </div>
        )}
      </div>
    </div>
  );
}
